function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "70",
  height: "70",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "a",
  d: "M0 0h70v70H0z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "b",
  maskContentUnits: "userSpaceOnUse",
  maskUnits: "objectBoundingBox",
  x: "0",
  y: "0",
  width: "70",
  height: "70",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#a"
}))), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("use", {
  stroke: "#DADCDF",
  mask: "url(#b)",
  strokeWidth: "2",
  fill: "#F5F5F5",
  strokeDasharray: "4",
  xlinkHref: "#a"
}), /*#__PURE__*/React.createElement("path", {
  d: "M37.442 27.155a2.5 2.5 0 012.478 2.167h3.067a2.5 2.5 0 012.5 2.5v9.428a2.5 2.5 0 01-2.5 2.5H27.165a2.5 2.5 0 01-2.5-2.5v-9.428a2.5 2.5 0 012.5-2.5h3.083a2.5 2.5 0 012.478-2.167h4.716zm1.5 2.667v-.167a1.5 1.5 0 00-1.5-1.5h-4.716a1.5 1.5 0 00-1.5 1.5v.167a.5.5 0 01-.5.5h-3.56a1.5 1.5 0 00-1.5 1.5v9.428a1.5 1.5 0 001.5 1.5h15.82a1.5 1.5 0 001.5-1.5v-9.428a1.5 1.5 0 00-1.5-1.5h-3.544a.5.5 0 01-.5-.5zM35 41a4.5 4.5 0 110-9 4.5 4.5 0 010 9zm0-1a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm7-6a1 1 0 110-2 1 1 0 010 2z",
  fill: "#DADCDF"
}))));